export const getPriceBeforeDiscount = (
  discountPercentage: number,
  price: number,
) => {
  return (price / ((100 - discountPercentage) / 100)).toFixed(2)
}
